import {FC} from 'react';
import base from './16px';
import large from './32px';
import {IconColorType, IconSize} from './types';

export type IconColorProps = {
    className?: string;
    icon: IconColorType;
    size?: IconSize;
};

const IconColor: FC<IconColorProps> = ({className, icon, size = 'lg'}) => {
    const SVG = size === 'lg' ? large[icon] : base[icon];

    return (
        <div className={className}>
            <SVG />
        </div>
    );
};

export default IconColor;
